import useCrossProductUrlWrapper from '@atlassiansox/analytics-cross-product-interaction-client/use-cross-product-url-wrapper';

import type { TownsquareApp } from '../store/context';

export const useGetCrossProductWrappedUrl = (
	bridge: string,
	url: string,
	app?: TownsquareApp,
): string => {
	const sourceApp = app ?? 'teams';
	const buildUrlWithAnalyticsParams = useCrossProductUrlWrapper({
		bridge,
		product: 'townsquare',
		subProduct: sourceApp,
	});

	return app !== undefined && app !== 'teams' ? buildUrlWithAnalyticsParams(url) : url;
};
